import React from 'react';

const EmptyReviewImage: React.FC = () => {
  return <img height="125vh" src="/images/emptyReviews.svg" alt="No reviews found" />;
};

export default EmptyReviewImage;
